import React from 'react';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import NormalContent from './normal';
import ExpandedContent from './expanded/index';
import GrowthGoalsUtils from './utils';
import ChartUtils from 'utils/chart';

import { findShowMethodForModal } from 'utils/runtime';
import { sharedModalReferences } from 'resources/common-values';

export default CreateReactClass({
    displayName: 'GrowthGoalsContainer',

    propTypes: {
        subject: PropTypes.instanceOf(Immutable.Map).isRequired,
        selectedTermNumber: PropTypes.number.isRequired,
        studentBid: PropTypes.string.isRequired,
        testEvents: PropTypes.instanceOf(Immutable.List).isRequired,
        mode: PropTypes.oneOf(['normal', 'expanded']),
        growthGoals: PropTypes.instanceOf(Immutable.List),
        terms: PropTypes.instanceOf(Immutable.List),
        studentTermData: PropTypes.instanceOf(Immutable.List),
        currentTerm: PropTypes.instanceOf(Immutable.Map),
        ritQuintiles: PropTypes.instanceOf(Immutable.Map),
        ritQuintilesLoaded: PropTypes.bool.isRequired,
        modalReferences: PropTypes.object,
        growthGoalNormsForStudent: PropTypes.instanceOf(Immutable.Map),
        growthGoalNormsForStudentLoaded: PropTypes.bool,
        growthProjections: PropTypes.instanceOf(Immutable.List),
        growthProjectionsLoaded: PropTypes.bool,
        expandedModule: PropTypes.string,
        linkingStudiesData: PropTypes.object,
        linkingStudiesLoaded: PropTypes.bool,
        keystoneTestEvent: PropTypes.object,
    },

    render() {
        if (!this.props.studentTermData || !this.props.terms) {
            return null;
        }

        const subjectId = this.props.keystoneTestEvent
            ? this.props.keystoneTestEvent.get('measurementScaleID')
            : this.props.subject.get('bid');

        const firstOpenTerm = GrowthGoalsUtils.getFirstOpenTerm(this.props.terms, subjectId, this.props.testEvents);
        const currentGrowthGoals = GrowthGoalsUtils.findCurrentGoals(this.props.growthGoals, firstOpenTerm);
        const pastGrowthGoals = GrowthGoalsUtils.findPastGoals(this.props.growthGoals, firstOpenTerm);
        const maxTestEvent = GrowthGoalsUtils.findMaxTestEventForMSID(this.props.testEvents, subjectId);
        const testToProjectFromForCurrentTerm = ChartUtils.findTestToProjectFrom(
            this.props.testEvents,
            this.props.currentTerm
        );
        const showSaveDataPrompt = findShowMethodForModal(
            this.props.modalReferences,
            sharedModalReferences.saveDataPrompt
        );
        const goalSettingTerms = GrowthGoalsUtils.findGoalSettingTerms(
            this.props.terms,
            firstOpenTerm,
            this.props.currentTerm,
            maxTestEvent,
            this.props.studentTermData
        ).sortBy((t) => t.get('termNumber'));

        return this.props.mode === 'normal' ? (
            <NormalContent
                currentGrowthGoals={currentGrowthGoals}
                firstOpenTerm={firstOpenTerm}
                goalSettingTerms={goalSettingTerms}
                key="growth-goals-default-content"
                pastGrowthGoals={pastGrowthGoals}
                studentBid={this.props.studentBid}
                subject={this.props.subject}
                testEvents={this.props.testEvents}
            />
        ) : (
            <ExpandedContent
                currentGrowthGoals={currentGrowthGoals}
                currentTerm={this.props.currentTerm}
                selectedTermNumber={this.props.selectedTermNumber}
                expandedModule={this.props.expandedModule}
                firstOpenTerm={firstOpenTerm}
                goalSettingTerms={goalSettingTerms}
                growthGoalNormsForStudent={this.props.growthGoalNormsForStudent}
                growthGoalNormsForStudentLoaded={this.props.growthGoalNormsForStudentLoaded}
                growthGoals={this.props.growthGoals}
                growthProjections={this.props.growthProjections}
                growthProjectionsLoaded={this.props.growthProjectionsLoaded}
                key="growth-goals-expanded-content"
                keystoneTestEvent={this.props.keystoneTestEvent}
                linkingStudiesData={this.props.linkingStudiesData}
                linkingStudiesLoaded={this.props.linkingStudiesLoaded}
                maxTestEvent={maxTestEvent}
                pastGrowthGoals={pastGrowthGoals}
                ritQuintiles={this.props.ritQuintiles}
                ritQuintilesLoaded={this.props.ritQuintilesLoaded}
                showSaveDataPrompt={showSaveDataPrompt}
                studentBid={this.props.studentBid}
                studentTermData={this.props.studentTermData}
                subject={this.props.subject}
                terms={this.props.terms}
                testToProjectFromForCurrentTerm={testToProjectFromForCurrentTerm}
                testEvents={this.props.testEvents}
            />
        );
    },
});
